import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_GOVERNORATE,
  AddGovernorateAction,
  DELETE_GOVERNORATE,
  DeleteGovernorateAction,
  GET_GOVERNORATE,
  GET_GOVERNORATES,
  GET_GOVERNORATE_SELECT_LIST,
  GetGovernorateAction,
  GetGovernorateSelectListAction,
  GetGovernoratesAction,
  UPDATE_GOVERNORATE,
  UpdateGovernorateAction,
} from "./actionTypes";
import {
  addGovernorateError,
  addGovernorateSuccess,
  deleteGovernorateError,
  deleteGovernorateSuccess,
  getGovernorateError,
  getGovernorateSelectListError,
  getGovernorateSelectListSuccess,
  getGovernorateSuccess,
  getGovernoratesError,
  getGovernoratesSuccess,
  updateGovernorateError,
  updateGovernorateSuccess,
} from "./actions";
import {
  addGovernorate,
  deleteGovernorate,
  getGovernorate,
  getGovernorateSelectList,
  getGovernorates,
  updateGovernorate,
} from "../../helpers/backend_helper";

function* getGovernoratesSaga({
  payload: { request, history },
}: GetGovernoratesAction) {
  try {
    const response: ResponseGenerator = yield call(
      getGovernorates,
      request as PaginateQuery
    );
    yield put(getGovernoratesSuccess(response.data));
  } catch (error) {
    yield put(getGovernoratesError(error));
  }
}

function* getGovernorateSaga({
  payload: { id, history },
}: GetGovernorateAction) {
  try {
    const response: ResponseGenerator = yield call(getGovernorate, id);
    yield put(getGovernorateSuccess(response.data));
  } catch (error) {
    yield put(getGovernorateError(error));
  }
}

function* getGovernorateSelectListSaga({
  payload: { history },
}: GetGovernorateSelectListAction) {
  try {
    const response: ResponseGenerator = yield call(getGovernorateSelectList);
    yield put(getGovernorateSelectListSuccess(response.data));
  } catch (error) {
    yield put(getGovernorateSelectListError(error));
  }
}

function* addGovernorateSaga({
  payload: { request, history },
}: AddGovernorateAction) {
  try {
    yield call(addGovernorate, request);
    yield put(addGovernorateSuccess());
  } catch (error) {
    yield put(addGovernorateError(error));
  }
}

function* updateGovernorateSaga({
  payload: { id, request, history },
}: UpdateGovernorateAction) {
  try {
    yield call(updateGovernorate, id, request);
    yield put(updateGovernorateSuccess());
  } catch (error) {
    yield put(updateGovernorateError(error));
  }
}

function* deleteGovernorateSaga({
  payload: { id, history },
}: DeleteGovernorateAction) {
  try {
    yield call(deleteGovernorate, id);
    yield put(deleteGovernorateSuccess());
  } catch (error) {
    yield put(deleteGovernorateError(error));
  }
}

function* GovernorateSaga() {
  yield takeEvery(GET_GOVERNORATES, getGovernoratesSaga);
  yield takeEvery(GET_GOVERNORATE, getGovernorateSaga);
  yield takeEvery(GET_GOVERNORATE_SELECT_LIST, getGovernorateSelectListSaga);
  yield takeEvery(ADD_GOVERNORATE, addGovernorateSaga);
  yield takeEvery(UPDATE_GOVERNORATE, updateGovernorateSaga);
  yield takeEvery(DELETE_GOVERNORATE, deleteGovernorateSaga);
}

export default GovernorateSaga;
